<template>
  <v-slide-group
    class="showMobile"
    multiple
    show-arrows
  >
    <v-slide-item
      v-for="(filterItem, i) in filters"
      :key="i"
      :class="[(isSubscription
        ? selectedFiltersArr.includes(filterItem.status)
        : selectedFilters.includes(filterItem.status))
        ? 'chip__active'
        : '',
      'chip__agrupaciones chip__filter v-chip',
      isSubscription ? 'chip__subscriptor' : '']"
    >
      <div>
        <v-badge
          v-if="isBadge"
          class="d-inline"
          inline
          :color="colors(filterItem.status)"
          dot
        ></v-badge>
        <div v-if="isSubscription" class="subscriptionChip">
          <span>
            {{ textFilters(filterItem.text) }}
          </span>
          <span>
            ({{ filterItem.subscribed }} de {{filterItem.total}})
          </span>
        </div>
        <span v-else @click="handleFilterClick(filterItem)">
          {{ textFilters(filterItem.text) }}
        </span>

        <!-- Slot para contenido personalizado -->
        <slot :filter="filterItem"></slot>

      </div>
    </v-slide-item>
  </v-slide-group>
</template>

<script>
export default {
  name: 'FiltersSlide',
  props: {
    filters: {
      type: Array,
      default: () => [],
    },
    selectedFilters: {
      type: Array,
      default: () => [],
    },
    isBadge: {
      type: Boolean,
      default: () => false,
    },
    isSubscription: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    selectedFiltersArr: [],
  }),

  created() {
    if (this.isSubscription) {
      this.selectedFiltersArr = ['Todo'];
    }
  },

  methods: {
    handleFilterClick(value) {
      const { status } = value;

      if (this.isSubscription) {
        this.selectedFiltersArr = [status];
      }

      this.$emit('filter-selected', value);
    },
    colors(status) {
      if (status) {
        return this.$getConst(`initialFilters.filterStatus.${status}.color`) || '#bbb';
      }
      return '#bbb';
    },
    textFilters(status) {
      const filtersAll = this.$getConst('initialFilters.all');

      if (status && filtersAll.includes(status)) {
        return this.$getConst(`initialFilters.filterStatus.${status}.text` || '');
      }

      return status;
    },
  },
};
</script>

<style scoped>
  .chip__active {
    background-color: #e6f1ee !important;
    border: 1px solid #27846d !important;
  }
  .chip__filter {
    margin: 0.3rem;
    cursor: pointer;
    background: #e0e0e0;
    border-radius: 16px;
    font-size: 14px;
    height: 32px;
    border-color: rgba(0, 0, 0, 0.12);
    color: rgba(0, 0, 0, 0.87);
  }
  .containerMyRequest{
    width: 100% !important;
  }
  .showMobile {
    display: none !important;
  }
  .subscriptionChip {
    display: flex;
    flex-direction: column;
  }
  .chip__subscriptor {
    height: 4rem !important;
  }
  .showMobile .v-slide-group__next,
  .showMobile .v-slide-group__prev {
    min-width: initial !important;
  }
  @media screen and (max-width: 600px) {
    .showWeb {
      display: none !important;
    }
    .showMobile {
      display: flex !important;
    }
    .myRequestScroll{
      overflow: hidden;
      white-space: nowrap;
      overflow-x: auto;
      padding-bottom: 4px;
    }
  }
</style>
